import { render, staticRenderFns } from "./SalesOrderSelector.vue?vue&type=template&id=d4c5248c"
import script from "./SalesOrderSelector.vue?vue&type=script&lang=js"
export * from "./SalesOrderSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports